import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { lenis } from "../App"; // importa el mismo Lenis

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    lenis.scrollTo(0); // suave al usar el mismo objeto
  }, [pathname]);

  return null;
};

export default ScrollToTop;